"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _disrupt = _interopRequireDefault(require("@ux/disrupt"));
var _dialog = _interopRequireDefault(require("@ux/dialog"));
var _legacy = require("./legacy");
const _excluded = ["children", "className", "focusLock", "onClose", "onEventBehind", "portalElem", "stretch", "strategy", "show"];
const UX_MODAL_CLASSNAME = 'ux-modal';
function Modal(_ref) {
  let {
      children,
      className,
      focusLock = true,
      onClose,
      onEventBehind,
      portalElem,
      stretch,
      strategy,
      show
    } = _ref,
    dialogProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  if (typeof show !== 'undefined' && !show) return null;
  if (!portalElem && (typeof document === 'undefined' || !document.body)) return null;
  return /*#__PURE__*/_react.default.createElement(_disrupt.default, {
    portalElem: portalElem || document.body,
    strategy: strategy || 'fixed',
    onClose: onClose,
    focusLock: focusLock,
    onEventBehind: onEventBehind,
    stretch: stretch
  }, /*#__PURE__*/_react.default.createElement(_dialog.default, (0, _extends2.default)({
    "aria-modal": true,
    role: "dialog",
    className: (0, _classnames.default)(UX_MODAL_CLASSNAME, className),
    space: {
      inline: true,
      block: true,
      as: _dialog.default.spaceOptions.MODULE
    },
    onClose: onClose
  }, (0, _legacy.transform)(dialogProps)), children));
}
Modal.propTypes = {
  /** Children to render within */
  children: _propTypes.default.node,
  /** Defaults to false. If `true`, enables focus lock with default options.
  * If object, passes props directly to react-focus-lock */
  focusLock: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object]),
  /** Callback that fires when the user attempts to leave the component */
  onClose: _propTypes.default.func,
  /** Callback that fires when an event occurs behind the component */
  onEventBehind: _propTypes.default.func,
  /** Element to attach the component to, use `document.body` for "modal" behavior */
  portalElem: _propTypes.default.object,
  /** Method to attach the backdrop */
  strategy: _propTypes.default.oneOf(['absolute', 'fixed']),
  /** Stretches the width of the container */
  stretch: _propTypes.default.bool,
  /** Adds actions */
  actions: _propTypes.default.node,
  /** Screenreader labels for sub-elements */
  ariaLabels: _propTypes.default.shape({
    /** Screen reader label for close button */
    close: _propTypes.default.string
  }),
  /** Provides a contrast overlay to the component */
  contrast: _propTypes.default.bool,
  /** Class name applied to component */
  className: _propTypes.default.string,
  /** Describes the importance of the message */
  emphasis: _propTypes.default.oneOf(['critical', 'warning', 'highlight', 'success', 'info', 'neutral', 'internal']),
  /** Adds icon to the title */
  icon: _propTypes.default.node,
  /** Assigns title to component for a11y */
  id: _propTypes.default.string,
  /** Card space configuration */
  space: _propTypes.default.object,
  /** Adds title with @ux/text */
  title: _propTypes.default.node,
  /** Whether the component should be visible or not */
  show: _propTypes.default.bool
};
var _default = exports.default = Modal;